export const common = {
  // Navigation
  nav: {
    home: '首页',
    products: '产品',
    repair: '维修·修理',
    about: '关于我们',
    news: '新闻',
    contact: '联系我们',
  },

  // Product names
  products: {
    silentUmbrella: '静音伞',
    braidUmbrella: '雅樱编织长伞',
    foldingUmbrella: '雨袋折叠伞',
    parasol: '晴雨两用伞',
    koshuWeaving: '甲州织',
    others: '其他',
  },

  // Language names
  language: {
    japanese: '日本語',
    english: 'English',
    chinese: '中文',
  },

  // Home page sections
  home: {
    // Hero section
    hero: {
      slide1Products: {
        product1Alt: '静音伞',
        product2Alt: '雅樱编织长伞',
        product3Alt: '雨袋折叠伞',
      },
      slide2: {
        title: '日本职人手工制作',
        alt: '主视觉图 02',
      },
      slide3: {
        title: '传承传统工艺',
        alt: '主视觉图 03',
      },
    },

    // About section
    about: {
      heading: '关于丸安洋伞',
      paragraph1: '丸安洋伞株式会社是一家专注于手工制作高品质雨伞的日本企业。我们秉承传统工艺，同时不断创新，为客户提供既实用又美观的雨伞产品。',
      paragraph2: '从传统的日本制雨伞到获得专利的静音雨伞，我们始终坚持品质第一的理念，每一把伞都凝聚着职人的匠心和技艺。',
      button: '了解更多',
      imageAlt: '公司介绍',
      stat1Value: '70+',
      stat1Label: '年经验',
      stat2Value: '100%',
      stat2Label: '品质保证',
      stat3Value: '50+',
      stat3Label: '产品种类',
    },

    // Products section
    productsSection: {
      heading: '产品一览',
      subtitle: 'PRODUCTS',
      learnMore: '查看详情',
    },

    // Silent Umbrella section
    silentUmbrella: {
      heading: '静音伞',
      subheading: 'SILENT UMBRELLA',
      title: '静音伞',
      subtitle: '获得专利的创新技术，大幅减少雨滴噪音',
      description: '我们开发的静音雨伞获得了专利技术。通过特殊的伞骨结构和面料设计，大幅减少了雨滴撞击时产生的噪音。这项创新技术让您在雨天也能享受宁静的时光。',
      recommendedUsesTitle: '推荐使用场景',
      use1: '周围的声音清晰可听',
      use2: '如同在树荫下般凉爽',
      use3: '雨天工作的理想选择',
      achievement1: '在大学学术会议上发表展示。',
      achievement2: '获得降低雨声效果的雨伞专利。',
      achievement3: '使用热成像相机与普通遮阳伞进行对比实验。',
      imageAlt1: '静音伞',
      imageAlt2: '静音伞细节',
      imageAlt3: '静音伞动画',
    },

    // Braid Umbrella section
    braidUmbrella: {
      heading: '雅樱编织长伞',
      subheading: 'MIYABI SAKURA BRAIDED UMBRELLA',
      description1: '采用传统日本编织工艺制作的高级长伞。',
      description2: '精美的樱花图案编织手柄，展现了日本传统工艺的精湛技艺。',
      paragraph1: '采用传统日本编织工艺制作的高级长伞。精美的樱花图案编织手柄，展现了日本传统工艺的精湛技艺。每一把伞都是由经验丰富的职人手工制作，确保品质和美观。',
      achievement1: '荣获"おもてなしセレクション"（待客之选）奖。',
      achievement2: '编织手柄实用新型专利已取得。',
      imageAlt1: '雅樱编织长伞',
      imageAlt2: '雅樱编织长伞细节',
    },

    // Folding Umbrella section
    foldingUmbrella: {
      heading: '雨袋折叠伞',
      subheading: 'RAIN POCKET FOLDING UMBRELLA',
      description1: '创新设计的折叠伞，配备专用的雨水收纳袋。',
      description2: '使用后可以将湿润的伞面收纳在防水袋中，避免弄湿包包或衣物。',
      description3: '在拥挤的电车和巴士上，是否为折叠伞的收纳而烦恼？',
      paragraph1: '创新设计的折叠伞，配备专用的雨水收纳袋。使用后可以将湿润的伞面收纳在防水袋中，避免弄湿包包或衣物。便携设计让您随时随地都能应对突然的降雨。',
      achievement1: '在电视节目中被报道介绍。',
      achievement2: '已取得专利。',
      imageAlt1: '雨袋折叠伞',
      imageAlt2: '雨袋折叠伞细节',
    },

    // Technology section
    technology: {
      heading: '我们的技术',
      button: '了解更多',
      imageAlt: '技术',
    },

    // Applications section
    applications: {
      heading: '应用场景',
      subtitle: '为各种场合找到完美的雨伞',
      dailyUse: '日常使用',
      dailyUseDesc: '完美防护日常的雨水和阳光',
      business: '商务场合',
      businessDesc: '适合商务场合的专业雨伞',
      specialEvents: '特殊场合',
      specialEventsDesc: '适合仪式和特殊活动的优雅设计',
      button: '查看产品',
    },

    // Repair section
    repair: {
      heading: 'SDGs',
      subheading: 'SDGs INITIATIVE',
      paragraph1: '我们的专业工匠提供全面的维修服务，延长您雨伞的使用寿命。从伞骨更换到面料修复，我们确保您的雨伞能为您服务多年。',
      paragraph2: '可持续雨伞护理',
      button: '了解更多维修信息',
      beforeRepairAlt: '维修前',
      afterRepairAlt: '维修后',
      beforeRepairLabel: '维修前',
      afterRepairLabel: '维修后',
    },

    // News section
    news: {
      heading: '新闻·通知',
      subtitle: 'NEWS',
      button: '查看所有新闻',
    },

    // Media section
    media: {
      imageAlt: '媒体采访',
      videoTitle: '雨袋折叠伞 - YouTube 视频播放器',
    },

    // Social section
    social: {
      facebookTitle: '\\Facebook 持续更新中/',
      facebookFeedText: 'Facebook 动态',
      facebookFollowText: '关注我们获取最新动态',
      purchaseTitle: '\\在此购买/',
      baseAlt: 'BASE',
      youtubeAlt: 'YOUTUBE',
      yahooShoppingAlt: 'Yahoo购物',
      instagramAlt: 'Instagram',
    },

    // Company section
    company: {
      heading: '大阪阿倍野 日本职人手工制作',
      subheading: '丸安洋伞株式会社',
      description: '我们的工坊位于大阪阿倍野的JR寺田町站附近。使用从前辈继承的技法和使用了半个世纪以上的工具进行手工制作。',
      button: '公司概况',
      imageAlt: '公司概况',
    },

    // Contact section
    contact: {
      heading: '联系我们',
      subtitle: 'CONTACT',
      phone: '06-6713-8308',
      businessHours: '营业时间：10:00-17:00（休息日：周六、周日、节假日）',
      emailButton: '发送邮件',
      onlineStoreAlt: '访问我们的在线商店',
    },
  },

  // Footer
  footer: {
    companyName: '丸安洋伞株式会社',
    logoAlt: '丸安洋伞株式会社 | 日本职人手工制作的雨伞',
    address: {
      postalCode: '〒545-0001',
      line1: '大阪市阿倍野区天王寺町北2-6-15',
      line2: '',
    },
    navigation: {
      home: '首页',
      productsHeading: '产品',
      silentUmbrella: '- 静音伞',
      braidUmbrella: '- 雅樱编织长伞',
      foldingUmbrella: '- 雨袋折叠伞',
      parasol: '- 晴雨两用伞',
      koshuOri: '- 甲州织',
      others: '- 其他',
      aboutUs: '关于我们',
      news: '新闻',
      repairService: '维修服务',
      contact: '联系我们',
      sitemap: '网站地图',
    },
    copyright: 'Copyright © 丸安洋伞株式会社 All rights reserved.',
    websiteBuilder: '网站建设',
  },

  // Common elements
  common: {
    learnMore: '了解详情',
    viewProducts: '查看产品',
    watchVideo: '观看视频',
    emailInquiry: '邮件咨询',
    businessHours: '营业时间：10:00-17:00（休息日：周六、周日、节假日）',
    phone: '06-6713-8308',
    onlineStore: '访问我们的在线商店',
  },

  // About page
  aboutPage: {
    heroTitle: '公司概况',
    heroSubtitle: 'COMPANY',
    companyHeading: '公司概况',
    companySubtitle: 'COMPANY',
    mapHeading: '交通路线',
    mapSubtitle: 'MAP',
    tableName: '公司名称',
    tableNameValue: '丸安洋傘株式会社',
    tableAddress: '地址',
    tableAddressValue: '〒545-0001 大阪市阿倍野区天王寺町北2-6-15',
    tableHours: '营业时间',
    tableHoursValue: '10:00 ～ 17:00',
    tableClosed: '休息日',
    tableClosedValue: '周六、周日、节假日、夏季、年末年初',
    tableTel: '电话',
    img1Alt: '丸安洋傘株式会社 外观',
    img2Alt: '丸安洋傘株式会社 工坊',
  },

  // Contact page
  contactPage: {
    heroTitle: '联系我们',
    heroSubtitle: 'CONTACT',
    intro1: '如有疑问、咨询及其他问题，请使用以下表格与我们联系。',
    intro2: '我们也接受电话咨询。',
    intro3: '填写各项内容后，请点击"发送"按钮。',
    formName: '姓名',
    formNameSei: '姓',
    formNameMei: '名',
    formFurigana: '假名',
    formFuriganaSei: '姓（假名）',
    formFuriganaMei: '名（假名）',
    formEmail: '电子邮件地址',
    formPhone: '电话号码',
    formMessage: '咨询内容',
    formMessagePlaceholder: '请在500个字符以内填写。',
    formMessageCount: '字符',
    formPrivacy: '个人信息处理方式',
    formPrivacyAgree: '我同意个人信息处理方式',
    required: '必填',
    submit: '发送',
    submitting: '发送中...',
    submitSuccess: '感谢您的咨询，我们将尽快与您联系。',
    submitError: '发送失败，请重试。',
    submitErrorNetwork: '发生错误，请重试。',
    infoTitle: '联系方式',
    infoPhone: '06-6713-8308',
    infoHours: '营业时间：10:00-17:00（休息日：周六、周日、节假日）',
    infoEmail: '邮件咨询',
    infoEmailSub: '请使用左侧的表格',
    privacyText1: '丸安洋傘株式会社（以下简称"本公司"）制定以下个人信息保护方针，建立个人信息保护体制，通过让全体员工认识到个人信息保护的重要性并切实执行，推进个人信息的保护。',
    privacyH1: '【个人信息管理】',
    privacyP1: '本公司将保持客户个人信息的准确性和最新状态，并采取维护安全系统、完善管理体制、彻底进行员工教育等必要措施，以防止对个人信息的未授权访问、丢失、损坏、篡改和泄露，实施安全对策，严格管理个人信息。',
    privacyH2: '【个人信息的使用目的】',
    privacyP2: '从客户处获得的个人信息，将用于回复咨询、发送本公司的相关邮件及资料、介绍本公司的服务和业务。',
    privacyH3: '【禁止向第三方披露、提供个人信息】',
    privacyP3: '本公司将妥善管理从客户处获得的个人信息，除以下情况外，不向第三方披露个人信息。',
    privacyList1: '经客户同意的情况',
    privacyList2: '为向客户提供所需服务而向受本公司委托的业务承包商披露的情况',
    privacyList3: '法律要求披露的情况',
    privacyH4: '【个人信息的安全对策】',
    privacyP4: '本公司为确保个人信息的准确性和安全性，采取了全面的安全措施。',
    privacyH5: '【本人查询】',
    privacyP5: '如客户希望查询、修改或删除本人的个人信息，我们将在确认本人身份后予以处理。',
    privacyH6: '【遵守法律法规及审查】',
    privacyP6: '本公司遵守适用于所保有个人信息的日本法律及其他规范，并适时审查和改善本方针内容。',
    privacyH7: '【联系方式】',
    privacyP7: '如对本公司个人信息处理方式有任何疑问，请通过以下方式联系我们。',
    privacyCompany: '丸安洋傘株式会社',
    privacyPostal: '〒545-0001',
    privacyAddress: '大阪市阿倍野区天王寺町北2-6-15',
    privacyTel: 'TEL：06-6713-8308',
  },

  // Braid Umbrella product page
  braidPage: {
    heroTitle: '雅樱组绳长伞',
    heroSubtitle: 'PRODUCT',
    breadcrumbHome: '首页',
    breadcrumbCurrent: '雅樱组绳长伞',
    catchphrase: '打造能真正称得上日本伞、蕴含日本美学意识的雨伞！',
    sec1Heading: '日本传统工艺组绳',
    sec1Body: '雅樱正是源于这一理念而诞生。使用令人联想到日本的材料——山樱木、甲州织，由工匠一把一把精心手工制作。甲州织面料是先将线染色后再织造，因此经纬线交织出富有层次的风格与触感，并具有独特的光泽感。',
    sec2Heading: '组绳与伞的融合',
    sec2Body: '从和服腰带绳中获得灵感，将精心编制的组绳缠绕在用奈良吉野产的珍贵山樱木削制而成的手柄上。雅樱的握持手感前所未有，触感舒适宜人，握伞时手柄不会滑动。甲州织与组绳独特的质感，成就了这把真正称得上日本制造的精品伞。',
    centerText: '将用十根绳子以平织手法手工编制的组绳，精心缠绕在山樱木手柄上。',
    sec3Heading: '象征吉祥的末广形',
    sec3Body: '自古以来，伞因其末广开展的形状被视为吉祥之物，常用于婚礼回礼和结婚礼物等场合。同时也非常适合作为馈赠心爱之人的礼物。万一出现问题，可随时按需修理，让您能长期使用。',
    videoHeading: '视频介绍',
    videoSubtitle: 'MOVIE',
    awardOmotenashi: '※荣获"款待之心"精选奖。',
    awardUtility: '※获得组绳手柄实用新型专利。',
    contactHeading: '联系我们',
    contactSubtitle: 'CONTACT',
    contactPhone: '06-6713-8308',
    contactHours: '营业时间：10:00-17:00（休息日：周六、周日、节假日）',
    contactEmail: '邮件咨询',
    onlineStoreAlt: '前往网络商店',
    img1Alt: '雅樱组绳长伞',
    img2Alt: '组绳与伞的融合',
    img3Alt: '象征吉祥的末广形',
  },
};
